import { BaseStore, StoreResponse } from './_base';

import { Project, projectService } from '../services/projects';


class ProjectStore extends BaseStore<Project> {

  async getProject(projectId: string, tryUpdate=true): Promise<Project> {
    const projects = this.list().filter(p => p.entry.id == projectId);
    if (projects.length > 0) return projects[0].entry;

    if (tryUpdate) {
      await this.retrieveAll();
      return this.getProject(projectId, false);
    }

    return {
      id: projectId,
      locations: [],
      name: 'Unbekannt',
      code: '??',
      color: '999999',
      group_assignments: [],
      device_assignments: [],
      timebased_rules: [],
    }

  }
}

export const projectStore = new ProjectStore("projects", projectService, 60 * 60 * 24);
